import { z } from 'zod';

export const SortOrder = {
    ASC: 'ASC',
    DESC: 'DESC',
} as const;

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder];

export const QuotesOrdersSortBy = {
    ORDER_CREATED_AT_DATE: 'entry_date',
    STATUS: 'status',
    CUSTOMER_NAME: 'customer_name',
    LINE_TOTAL: 'total_amount_net',
    GROSS_MARGIN: 'total_margin',
} as const;

export type QuotesOrdersSortBy = (typeof QuotesOrdersSortBy)[keyof typeof QuotesOrdersSortBy];

export const quoteOrderSortSchema = z
    .object({
        field: z.enum(QuotesOrdersSortBy),
        direction: z.enum(SortOrder),
    })
    .optional()
    .nullable();

export type QuoteOrderSort = z.infer<typeof quoteOrderSortSchema>;

export const CustomerSortBy = {
    CUSTOMER_NAME: 'customerName',
    REVENUE_YTD: 'revenueYtdThisYear',
    REVENUE_LYTD: 'revenueYtdLastYear',
    REVENUE_YTD_DELTA: 'revenueYtdDeltaAmount',
    REVENUE_YTD_DELTA_PERCENT: 'revenueYtdDeltaPercentage',
    TTM: 'revenueTtm',
    TTM_PREVIOUS: 'revenueTtmLastYear',
    TTM_DELTA: 'deltaDifferenceTtm',
    LAST_ORDER_DATE: 'lastOrderDate',
    INSIGHTS_COUNT_UNUSED: 'insightsCountUnused',
    INSIGHTS_SUM_ALL: 'insightSumAll',
    INSIGHTS_SUM_UNUSED: 'insightsSumUnused',
    INSIGHTS_SUM_OPPORTUNITY: 'insightSumOpportunity',
    INSIGHTS_SUM_RISK: 'insightSumRisk',
    STATUS: 'status',
    // Gross Margin
    GROSS_MARGIN_TTM: 'grossMarginTtm',
    GROSS_MARGIN_TTM_DELTA: 'deltaGmTtm',
    GROSS_MARGIN_YTD: 'grossMarginYtdThisYear',
    GROSS_MARGIN_YTD_DELTA: 'gmYtdDeltaAmount',
    // Visit metrics (manager view)
    DOCUMENTED_VISITS: 'documentedVisits',
    VISITS_PER_100K: 'visitsPer100kRevenue',
    LAST_VISIT: 'lastVisitDate',
} as const;

export type CustomerSortBy = (typeof CustomerSortBy)[keyof typeof CustomerSortBy];

export const customerSortSchema = z
    .object({
        field: z.enum(CustomerSortBy),
        direction: z.enum(SortOrder),
    })
    .optional()
    .nullable();

export type CustomerSort = z.infer<typeof customerSortSchema>;

export const sortingSchema = z.array(
    z.object({
        id: z.string(),
        desc: z.boolean(),
    }),
);
